import { render, staticRenderFns } from "./share-user-stat.vue?vue&type=template&id=d72049d4&scoped=true&"
import script from "./share-user-stat.vue?vue&type=script&lang=js&"
export * from "./share-user-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72049d4",
  null
  
)

export default component.exports